import {
  DEVICE_DETAILS_FETCH_STARTED,
  DEVICE_DETAILS_FETCH_SUCCEEDED,
  DEVICE_DETAILS_FETCH_FAILED,
  DEVICE_DETAILS_CLEAR
} from '#action/types';
import { webPortalApi } from '#config/web-portal-api';
import { snackBarError } from '#action/fetch';
import { getRequestOptions } from '#helper';

let abortController = new AbortController();

export const fetchDeviceDetails = (deviceUID, forceUpdate) => async dispatch => {
  try {
    abortController.abort();
    const params = {
      uids: deviceUID,
      occupierDetails: 1
    };

    if (forceUpdate) {
      params.forceUpdate = 1;
    }

    const searchParams = new URLSearchParams(params);

    const url = webPortalApi.buildApiUrl(`device/distinct/details?${searchParams.toString()}`);

    dispatch({
      type: DEVICE_DETAILS_FETCH_STARTED
    });
    abortController = new AbortController();
    const { signal } = abortController;
    // Debounce to do not send multiple requests in short time
    await new Promise(res => {
      setTimeout(() => {
        res();
      }, 200);
    });
    const res = await fetch(url, { ...getRequestOptions(), signal });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }
    if (!res.ok) {
      dispatch(
        snackBarError({
          message: 'Error in request'
        })
      );
    }

    const [device] = await res.json();

    if (device.projects.length) {
      const projectIds = device.projects;
      const projectsRes = await fetch(webPortalApi.buildApiUrl(`project?ids=${projectIds.join(',')}`), getRequestOptions());
      device.projectsDetails = await projectsRes.json();
    }

    dispatch({
      type: DEVICE_DETAILS_FETCH_SUCCEEDED,
      payload: device
    });
  } catch (e) {
    if (e.name === 'AbortError') {
      return;
    }
    dispatch({
      type: DEVICE_DETAILS_FETCH_FAILED,
      error: e
    });
  }
};

export const clearDeviceDetails = () => dispatch => {
  abortController.abort();
  dispatch({
    type: DEVICE_DETAILS_CLEAR
  });
};
